import { motion } from 'framer-motion';
import { useInViewScroll, StackedContent, NascarLogo } from 'ui';

interface HalfImgHeroProps {
  variant?: 'horizontal' | 'vertical';
  bgimg?: string;
  bgColor?: string;
  maxHeight1000: boolean;
  content?: object;
  nascarLogo?: boolean;
  bannerActive?: boolean;
  sectionPadding?: string;
  copyPadding: boolean;
  imgagePositionTop: boolean;
  center?: boolean;
}

export const HalfImgHero = ({
  variant = 'horizontal',
  bgimg,
  bgColor = 'white',
  maxHeight1000 = false,
  sectionPadding = '',
  content,
  nascarLogo = false,
  bannerActive = false,
  copyPadding = true,
  imgagePositionTop = false,
  center = false,
}: HalfImgHeroProps) => {
  const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100vh', 'end 0vh']);

  return (
    <motion.section ref={ref} className={`relative z-40 flex w-full justify-center bg-${bgColor} ${sectionPadding}`} data-testid={'nascar-section'}>
      <div
        className={`h-full w-full ${variant !== 'vertical' ? (bannerActive ? 'lg:h-[calc(100vh-129px)]' : 'lg:h-[calc(100vh-89px)]') : ''} flex ${
          maxHeight1000 ? 'max-h-[1000px]' : 'max-h-none'
        } ${variant === 'vertical' ? 'flex-col' : 'flex-col-reverse lg:flex-row'}`}
      >
        {/* Stacked content */}
        <div
          className={`flex w-full flex-col items-center justify-center ${copyPadding ? '2xl:px-24' : 'px-none'} ${
            variant === 'vertical' ? 'pb-8 pt-16 xl:pb-12 xl:pt-32' : 'content-wrapper-x py-8 lg:w-1/2'
          }`}
        >
          {nascarLogo && <NascarLogo className="hidden justify-start p-6 pl-0 lg:flex" />}
          <StackedContent minHeight space left={!center} center={center} mobileCenterLg={nascarLogo} content={content} />
        </div>

        {/* Image */}
        <div
          className={`w-full ${variant === 'vertical' ? 'mx-auto mb-8 h-[300px] max-w-[2040px] xl:mb-16 xl:h-[592px]' : 'h-full min-h-[400px] lg:w-1/2'}`}
          style={{
            backgroundImage: `url('${bgimg}')`,
            backgroundPosition: `${imgagePositionTop ? 'top' : 'center'}`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Dradient overlay */}
          {variant === 'vertical' && (
            <div
              style={{
                display: 'none',
              }}
              className="absolute left-1/2 top-0 z-40 mx-auto h-full w-[2040px] -translate-x-1/2"
              aria-hidden
            >
              <style jsx>{`
                @media (min-width: 2040px) {
                  div[aria-hidden] {
                    display: block !important;
                  }
                }
              `}</style>{' '}
              <div className="from-xumoDarkPlum via-xumoDarkPlum/40 pointer-events-none absolute left-0 top-0 h-full w-[100px] bg-gradient-to-r to-transparent" />
              <div className="from-xumoDarkPlum via-xumoDarkPlum/40 pointer-events-none absolute right-0 top-0 h-full w-[100px] bg-gradient-to-l to-transparent" />
            </div>
          )}
        </div>
        {/* NASCAR Logo for small screens */}
        {nascarLogo && <NascarLogo className="flex justify-center p-6 min-[250px]:p-10 lg:hidden" />}
      </div>
    </motion.section>
  );
};
